import React, { useState, useEffect } from "react";
import { BsCurrencyRupee } from "react-icons/bs";

export default function CustomPayment({ creditErrorBlock,formik }) {
    const {
        consultationCost,
        specializationCost,
        discountPercentage = 10, // dynamic hidden discount
    } = creditErrorBlock;

    const baseTotal = consultationCost + specializationCost;
    const basePay = baseTotal;

    const [inputAmount, setInputAmount] = useState('');
    const [finalTotal, setFinalTotal] = useState(basePay);

    useEffect(() => {
        if (inputAmount === '') {
            setFinalTotal(basePay);
            formik?.setFieldValue('ConsultationAmt', (basePay));
        } else {
            const parsedAmount = parseInt(inputAmount, 10);
            if (!isNaN(parsedAmount)) {
                setFinalTotal(basePay + parsedAmount);
                console.log("commong though",(basePay + parsedAmount))
                formik?.setFieldValue('ConsultationAmt', (basePay + parsedAmount));
                
            }
        }
    }, [inputAmount, basePay]);

    const handleInputChange = (e) => {
        const value = e.target.value;

        // Remove non-digits and limit to 10 digits
        const numericOnly = value.replace(/\D/g, '').slice(0, 10);
        setInputAmount(numericOnly);
    };

    return (
        <div className="flex items-center gap-2 p-2 rounded-[10px] bg-sky-50 flex-col w-full px-3 py-2">
            <div className="bg-[#FEFBEA] border border-[#FDE487] text-[#8B3913] font-medium px-3 py-2 rounded-md w-full">
                Base Pay: ₹ {basePay}
            </div>

            <input
                type="text"
                value={inputAmount}
                onChange={handleInputChange}
                onKeyUp={handleInputChange}
                placeholder="Enter amount"
                className="w-full border rounded-md px-4 py-2 outline-none focus:ring-2 focus:ring-blue-400"
                inputMode="numeric"
                maxLength={5}
            />

            <div className="flex justify-between font-medium text-[#333] border-t pt-4 px-3 w-full">
                <div>Total</div>
                <div className="flex items-center">
                    <BsCurrencyRupee />
                    <span>{finalTotal}</span>
                </div>
            </div>
        </div>
    );
}
